import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const getPath = (obj, path) => path.split(".").reduce((o, k) => (o == null ? undefined : o[k]), obj);

export const setPath = (obj, path, value) => {
  const [k, ...rest] = path.split(".");
  return { ...obj, [k]: rest.length ? setPath(obj?.[k] || {}, rest.join("."), value) : value };
};

export const Section = ({ title, children, testId }) => (
  <div className="space-y-3" data-testid={testId}>
    <p className="text-xs font-semibold uppercase tracking-wide text-slate-500 border-b border-slate-100 pb-1">{title}</p>
    <div className="grid sm:grid-cols-2 gap-3">{children}</div>
  </div>
);

export const Field = ({ label, path, form, set, type = "text", disabled, wide, required, ...rest }) => (
  <div className={wide ? "sm:col-span-2" : ""}>
    <Label className="text-xs">{label}{required ? " *" : ""}</Label>
    <Input type={type} value={getPath(form, path) ?? ""} disabled={disabled} required={required}
      onChange={(e) => set(path, e.target.value)} data-testid={`user-${path.replace(/\./g, "-")}`} className="mt-1 disabled:opacity-100 disabled:text-slate-800 disabled:bg-slate-50" {...rest} />
  </div>
);

export const Choice = ({ label, path, form, set, options, disabled, testId }) => (
  <div>
    <Label className="text-xs">{label}</Label>
    <div className="mt-1 flex flex-wrap gap-1.5" data-testid={testId}>
      {options.map(([v, l]) => (
        <button key={v} type="button" disabled={disabled} onClick={() => set(path, v)} data-testid={`${testId}-${v}`}
          className={`px-3 py-1.5 rounded-md border text-xs transition-colors ${getPath(form, path) === v
            ? "bg-navy text-white border-navy" : "bg-white text-slate-600 border-slate-200 hover:bg-slate-50"} ${disabled ? "opacity-70 cursor-not-allowed" : ""}`}>
          {l}
        </button>
      ))}
    </div>
  </div>
);
